import { environment } from '../../../environments/environment';

export enum RedeAdsEnum {
    GOOGLE_ADS = 1,
    META_ADS = 2,
    NEWSBREAK = 3,
    TABOOLA = 4,
    TIK_TOK = 5,
    MGID = 6,
    REVCONTENT = 7,
}

export const REDE_ADS_ROUTE_SLUG: Record<RedeAdsEnum, string> = {
    [RedeAdsEnum.GOOGLE_ADS]: 'google-ads',
    [RedeAdsEnum.META_ADS]: 'meta-ads',
    [RedeAdsEnum.NEWSBREAK]: 'newsbreak',
    [RedeAdsEnum.TABOOLA]: 'taboola',
    [RedeAdsEnum.TIK_TOK]: 'tik-tok',
    [RedeAdsEnum.MGID]: 'mgid',
    [RedeAdsEnum.REVCONTENT]: 'revcontent',
};

const ACCOUNT_CENTER_BASE = '/v2/integrations/account-center';

export function redeAdsProfileListPath(rede: RedeAdsEnum): string {
    return `${ACCOUNT_CENTER_BASE}/${REDE_ADS_ROUTE_SLUG[rede]}-profile-list`;
}

/** Backend replaces the literal `profile_id` segment with the created profile id. */
export function redeAdsOAuthAccountsRedirectUri(rede: RedeAdsEnum.GOOGLE_ADS | RedeAdsEnum.META_ADS): string {
    return `${environment.urlSite}${ACCOUNT_CENTER_BASE}/${REDE_ADS_ROUTE_SLUG[rede]}-profile/profile_id/accounts`;
}

export function redeAdsProfileListPathFromSlug(slug: string): string | null {
    const isKnownSlug = Object.values(REDE_ADS_ROUTE_SLUG).includes(slug);
    if (!isKnownSlug) {
        return null;
    }

    return `${ACCOUNT_CENTER_BASE}/${slug}-profile-list`;
}
